import { StyleSheet } from '@react-pdf/renderer';

export const createStyles = (color) => StyleSheet.create({
    body: {
        flexDirection: 'row',
        fontFamily: 'Helvetica',
        fontSize: 10,
        lineHeight: 1.5,
    },
    leftColumn: {
        width: '30%',
        padding: 20,
        backgroundColor: color,
        color: 'white'
    },
    headerLeft: { marginBottom: 30 },
    nome: {
        fontSize: 22,
        fontFamily: 'Helvetica-Bold',
        lineHeight: 1.2,
        marginBottom: 15,
    },
    contato: { fontSize: 10, marginBottom: 5 },
    sectionLeft: { marginBottom: 20 },
    titleLeft: { fontSize: 14, fontFamily: 'Helvetica-Bold', marginBottom: 10, textTransform: 'uppercase' },
    socialItem: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 5,
    },
    socialIcon: {
        width: 12,
        height: 12,
        marginRight: 8,
        color: 'white',
    },
    socialLink: {
        fontSize: 10,
        color: 'white',
        textDecoration: 'none',
    },
    rightColumn: {
        width: '70%',
        padding: 30,
    },
    sectionRight: {
        marginBottom: 20,
    },
    titleRight: {
        fontSize: 16,
        fontFamily: 'Helvetica-Bold',
        color: '#333',
        borderBottomWidth: 2,
        borderBottomColor: color,
        paddingBottom: 3,
        marginBottom: 10,
        textTransform: 'uppercase',
    },
    item: { marginBottom: 15 },
    itemHeader: { flexDirection: 'row', justifyContent: 'space-between' },
    itemTitle: { fontFamily: 'Helvetica-Bold', fontSize: 12 },
    itemSubTitle: { fontStyle: 'italic', color: '#555' },
    itemDate: { fontStyle: 'italic', color: 'grey', fontSize: 10 },
    itemDescription: { marginTop: 5, textAlign: 'justify' },
});
